<div id="Area-Chat">
  <div class="panel" id="chatTransferWorkspace">
    <div class="panel-title">
      <h3 class="title" *ngIf="!isConference">{{ 'agent:contact.workspace.phone.transfer.title' | translate }}</h3>
      <h3 class="title" *ngIf="isConference">{{ 'agent:contact.workspace.chat.conference.title' | translate }}</h3>
    </div>
    <div *ngIf="!isDialingTarget && !waitForWSResponse && !waitForWSDomainSkillResponse" class="panel-body">
      <form name="transferForm">
        <!-- TRANSFER TARGET TYPE SELECTION -->
        <div *ngIf="!isConference" style="margin-bottom: 20px">
          <label for="targetType">{{ 'agent:contact.workspace.phone.transfer.target' | translate }}</label>
          <select id="targetType" name="targetType" [(ngModel)]="transfer.targetType" (change)="onTargetChange()">
            <option *ngFor="let target of availableTargetTypes" [ngValue]="target">{{ getTargetLabel(target) }}</option>
          </select>
        </div>
        <!-- SKILL TARGET -->
        <div *ngIf="transfer.targetType === TransferTarget.SKILL" id="skillTarget">
          <fieldset>
            <legend>{{ 'agent:contact.workspace.phone.transfer.parameters' | translate }}</legend>
            <label for="skillSelection" class="smt">{{ 'agent:contact.workspace.phone.transfer.skill' | translate }}</label>
            <div class="smt" style="width: 100%; margin-top: 5px">
              <cng-chosen-field
                [htmlId]="'skillSelection'"
                name="skill"
                [multiple]="true"
                [collection]="availableSkills"
                [fieldPlaceholder]="'agent:contact.workspace.phone.transfer.skills_placeholder'"
                (callback)="updateTransferTarget($event)"
              ></cng-chosen-field>
              <span class="formError" *ngIf="noResultsAgentTarget && transfer.targetType === TransferTarget.SKILL" role="alert">{{
                'agent:contact.workspace.phone.transfer.agent_no_available' | translate
              }}</span>
            </div>
          </fieldset>
        </div>

        <!-- TEAM TARGET -->
        <div *ngIf="transfer.targetType === TransferTarget.TEAM" id="teamTarget">
          <fieldset>
            <legend>{{ 'agent:contact.workspace.phone.transfer.parameters' | translate }}</legend>
            <label for="teamSkillSelection">{{ 'agent:contact.workspace.phone.transfer.team_skills' | translate }}</label>
            <div style="width: 100%; margin-top: 5px">
              <cng-chosen-field
                class="selectSkills"
                [htmlId]="'teamSkillSelection'"
                name="teamSkill"
                [collection]="availableSkills"
                [multiple]="true"
                [fieldPlaceholder]="'agent:contact.workspace.phone.transfer.skills_placeholder'"
                [resetSwitch]="skillsResetSwitch"
                (callback)="updateCandidateTeamList($event)"
                required
              >
              </cng-chosen-field>
              <button type="button" id="resetSkills" (click)="resetTeamSkills()" style="width: fit-content">
                {{ 'agent:contact.workspace.mail.transfer.team_skills_reset' | i18next }}
              </button>
            </div>

            <div class="smt" style="margin-top: 5px">
              <label for="teamSelection">{{ 'agent:contact.workspace.phone.transfer.team' | translate }}</label>
              <div style="width: 100%; margin-top: 5px">
                <cng-chosen-field
                  [htmlId]="'teamSelection'"
                  name="team"
                  [collection]="availableTeams"
                  [fieldPlaceholder]="'agent:contact.workspace.phone.transfer.team_placeholder'"
                  (callback)="updateTransferTarget($event)"
                  required
                ></cng-chosen-field>
                <span class="formError" *ngIf="noResultsTeamTarget && transfer.targetType === TransferTarget.TEAM" role="alert">{{
                  'agent:contact.workspace.phone.transfer.team_no_available' | translate
                }}</span>
              </div>
            </div>
          </fieldset>
        </div>

        <!-- AGENT TARGET -->
        <div *ngIf="transfer.targetType === TransferTarget.AGENT" id="agentTarget">
          <fieldset>
            <legend>{{ 'agent:contact.workspace.phone.transfer.parameters' | translate }}</legend>
            <label for="agentFilterType" style="margin-right: 10px">{{
              'agent:contact.workspace.phone.transfer.agent_element' | translate
            }}</label>
            <div style="width: 100%; margin-top: 5px">
              <select id="agentFilterType" name="agentFilterType" [(ngModel)]="agentFilterType" (change)="onTargetChange()">
                <option value="teamOrGroup">{{ 'agent:contact.workspace.phone.transfer.team_or_group_filter' | translate }}</option>
                <option value="skill">{{ 'agent:contact.workspace.phone.transfer.skill_filter' | translate }}</option>
              </select>
              <label for="transferTargetType" class="nodisplay">{{
                'agent:contact.workspace.phone.transfer.team_or_group_filter' | translate
              }}</label>
              <select
                id="transferTargetType"
                name="transferTargetType"
                *ngIf="transfer.targetType === TransferTarget.AGENT && agentFilterType === 'teamOrGroup'"
                [(ngModel)]="teamOrGroupFilter"
                (change)="onTargetTeamOrGroupChange()"
              >
                <optgroup *ngIf="haveGroupFilter" label="{{ 'agent:contact.workspace.phone.transfer.group' | translate }}">
                  <option *ngFor="let filter of availableGroupFilters" [ngValue]="filter">{{ filter.name }}</option>
                </optgroup>
                <optgroup *ngIf="haveTeamFilter" label="{{ 'agent:contact.workspace.phone.transfer.team' | translate }}">
                  <option *ngFor="let filter of availableTeamFilters" [ngValue]="filter">{{ filter.name }}</option>
                </optgroup>
              </select>

              <cng-chosen-field
                [htmlId]="'skillSelection'"
                name="skill"
                *ngIf="transfer.targetType === TransferTarget.AGENT && agentFilterType === 'skill'"
                [collection]="availableSkillFilters"
                [fieldPlaceholder]="'agent:contact.workspace.phone.transfer.skills_placeholder'"
                (callback)="onTargetSkillChange($event)"
              ></cng-chosen-field>

              <div *ngIf="transfer.targetType === TransferTarget.AGENT">
                <label for="agentTargetInput" class="nodisplay">{{
                  'agent:contact.workspace.phone.transfer.agent_placeholder' | translate
                }}</label>
                <cng-chosen-field
                  [htmlId]="'agentTargetInput'"
                  name="agent"
                  [collection]="resultsAgentTarget"
                  [fieldPlaceholder]="'agent:contact.workspace.phone.transfer.agent_placeholder'"
                  (callback)="updateTransferTarget($event)"
                  (keyupCallback)="onCsrChange($event)"
                ></cng-chosen-field>
              </div>

              <span class="formError" *ngIf="noResultsAgentTarget && transfer.targetType === TransferTarget.AGENT" role="alert">{{
                'agent:contact.workspace.phone.transfer.agent_no_available' | translate
              }}</span>
            </div>
          </fieldset>
        </div>

        <div
          *ngIf="
            transfer.targetType === TransferTarget.SKILL ||
            transfer.targetType === TransferTarget.AGENT ||
            transfer.targetType === TransferTarget.TEAM
          "
        >
          <div style="width: 100%">
            <label for="transferCommentTextArea">{{ 'agent:contact.workspace.phone.transfer.comment' | translate }}</label>
          </div>
          <textarea
            id="transferCommentTextArea"
            style="width: 37.6em; height: 3.4em"
            name="transferCommentTextArea"
            [(ngModel)]="transfer.comment"
          ></textarea>
        </div>
      </form>
    </div>
    <div *ngIf="isDialingTarget" class="panel-body center">
      <div class="background_loader">
        <div class="center_loader">
          <div class="image_loader"></div>
        </div>
        <div *ngIf="!isConference" class="text_center">
          {{ 'agent:contact.workspace.chat.transfer.dialing_target' | translate }}
        </div>
        <div *ngIf="isConference" class="text_center">
          {{ 'agent:contact.workspace.chat.transfer.dialing_target_conference' | translate }}
        </div>
      </div>
    </div>

    <div *ngIf="waitForWSResponse || waitForWSDomainSkillResponse" class="panel-body center">
      <div class="application-loading-overlay">
        <div class="loader"></div>
      </div>
    </div>
  </div>
  <chat-banner></chat-banner>
</div>
